import { render, staticRenderFns } from "./DetailPdfEntry.vue?vue&type=template&id=1ca52494&scoped=true"
import script from "./DetailPdfEntry.vue?vue&type=script&lang=js"
export * from "./DetailPdfEntry.vue?vue&type=script&lang=js"
import style0 from "./DetailPdfEntry.vue?vue&type=style&index=0&id=1ca52494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca52494",
  null
  
)

export default component.exports